<div
  class="flex h-full flex-col overflow-hidden rounded-radius-primary bg-background-fixed drop-shadow-foreground-primary-100-shadow-30 dark:drop-shadow-foreground-secondary-100-shadow-30"
>
  <div class="flex flex-col gap-y-2 border-b border-foreground-primary-12 pt-1 pb-1">
    <app-text-input
      #searchInput
      inputId="quick-navigation-input"
      type="search"
      autocomplete="off"
      inputRole="combobox"
      [ariaLabel]="'quick-navigation.title' | translate"
      ariaControls="quick-navigation-options"
      [ariaActiveDescendant]="activeOptionId()"
      [ariaExpanded]="options().length > 0"
      [placeholder]="'quick-navigation.placeholder' | translate"
      leftIcon="search-20"
      inputClasses="!pl-[36px]"
      [ngModel]="search()"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSearchInput($event)"
    ></app-text-input>
  </div>

  <div id="quick-navigation-options" role="listbox" class="grow flex flex-col overflow-y-auto text-sm">
    @for (option of options(); track option.id; let index = $index; let last = $last) {
      <div
        class="shrink-0 flex flex-col cursor-pointer"
        [class.border-b]="!last"
        [class.border-foreground-primary-12]="!last"
        [class.font-semibold]="index === activeIndex()"
        [class.text-action-primary]="index === activeIndex()"
        [class.bg-background-container-tertiary]="index === activeIndex()"
      >
        <a
          #optionElement
          [id]="option.id"
          [routerLink]="option.route"
          role="option"
          [attr.aria-selected]="index === activeIndex()"
          class="grow flex items-center gap-2 pl-4 pr-6 min-h-[33px]"
          (mouseenter)="activeIndex.set(index)"
          (click)="onOptionSelect($event)"
        >
          <span>
            @for (part of option.labelParts; track $index) {
              <span [class.bg-action-primary-30]="part.isMatch" [class.text-action-primary]="part.isMatch">{{ part.text }}</span>
            }
          </span>
        </a>
      </div>
    } @empty {
      <div class="flex shrink-0 items-center h-[45px] pl-3">{{ 'quick-navigation.no-results' | translate }}</div>
    }
  </div>
</div>
